const AdminRoutes = [
 
  ];
  
  export default AdminRoutes;